import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

const AppWrapper = (
  <React.StrictMode>
    <HelmetProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// react-snap snapshot'ı (SEO için hazır HTML) hydrate EDİLMEZ, yerine normal render yapılır:
// react-snap DOM'u tarayıcıdan kopyaladığı için React'in yan yana metin düğümleri arasına koyduğu
// <!-- --> ayraçları yok; tarayıcı bu metinleri birleştirince hydration her sayfada başarısız oluyor
// (#418) ve React zaten baştan çiziyordu. createRoot snapshot'ı ilk render'da doğrudan değiştirir.
ReactDOM.createRoot(rootElement).render(AppWrapper);
